<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined" />


<breadcrumb [paginas]="[
        { route: '/home', name: 'Home' },
        { route: '/relatorio-pec-psicologo.component', name: 'Relatório' }
    ]" />




<section class="section-saudacao" aria-labelledby="saudacao-title">
  <div class="container">
    <p>
      <b>Olá,</b> {{this.userLogado?.flPsicologo ? "Psicólogo(a)": this.atribuicoesLogin.NomePerfil }}<br />
      <b>{{this.userLogado?.flPsicologo ? this.userLogado?.nome : this.atribuicoesLogin.Nome}}</b>
    </p>
  </div>
</section>

<br />
<br />


<section class="titulo-relatorio">
  <div class="container">
    <h2>Relatório - Psicólogos</h2>
  </div>
</section>

<br />

<app-filtro-padrao (filtroEmitter)="listeningFiltroEmitter($event)"
                   [template]="3"
                   [usePolo]="true"
                   [listarPsicologo]="true"
                   [usePeriodo]="true"
                   [atividadeDE]="true"
                   [textoLupa]="true"
                   [dividir2filas]="true">
</app-filtro-padrao>

<br />
<br />

<section #pdfContent id="pdf-content">

  <section class="section-info-periodo">
    <div class="container">
      <div class="header-info">
        <h1>Informações do período</h1>
        <button class="btn-download-pdf" (click)="ExportarComoPDF()">
          <i class="material-symbols-outlined">download</i>
          <span>PDF</span>
        </button>
      </div>

      <div class="info-grid">
        <div *ngIf="infoPeriodo.polo !== '-'">
          <b>Polo</b>
          <span>{{ infoPeriodo.polo }}</span>
        </div>
        <div *ngIf="infoPeriodo.diretoria !== '-'">
          <b>URE</b>
          <span>{{ infoPeriodo.diretoria }}</span>
        </div>
        <div *ngIf="infoPeriodo.escola !== '-'">
          <b>Escola</b>
          <span>{{ infoPeriodo.escola }}</span>
        </div>
        <div *ngIf="infoPeriodo.psicologo !== '-'">
          <b>Psicólogo</b>
          <span>{{ infoPeriodo.psicologo }}</span>
        </div>
        <div *ngIf="infoPeriodo.ciclo !== '-'">
          <b>Ciclo</b>
          <span>{{ infoPeriodo.ciclo }}</span>
        </div>
        <div *ngIf="infoPeriodo.dataInicio && infoPeriodo.dataInicio !== '-' ">
          <b>Data início:</b>
          <span>
            {{
              (infoPeriodo.dataInicio && infoPeriodo.dataInicio !== '-' && infoPeriodo.dataInicio !== '')
                ? (infoPeriodo.dataInicio | date:'dd/MM/yyyy')
                : '-'
            }}
          </span>
        </div>

        <div *ngIf="infoPeriodo.dataFim && infoPeriodo.dataFim !== '-'">
          <b>Data fim:</b>
          <span>
            {{
              (infoPeriodo.dataFim && infoPeriodo.dataFim !== '-' && infoPeriodo.dataFim !== '')
                ? (infoPeriodo.dataFim | date:'dd/MM/yyyy')
                : '-'
            }}
          </span>
        </div>
      </div>
    </div>
  </section>
  <section class="section-info">
    <div class="container">
      <div class="header-relatorio">
        <br />
        <br />
        <h1>Relatórios de Atendimento</h1>
      </div>
      <div class="relatorio-info">
        <div>
          <i class="material-symbols-outlined icon certo">check_circle</i>
          <b>Relatórios Validados</b>
          <span>{{this.validadosNaoValidados.validadosFormatado}}</span>
        </div>
        <div>
          <i class="material-symbols-outlined icon temporario">pace</i>
          <b>Relatórios Não Validados</b>
          <span>{{this.validadosNaoValidados.naoValidadosFormatado}}</span>
        </div>
        <div>
          <i class="material-symbols-outlined icon errado">disabled_by_default</i>
          <b>Sem Atividade</b>
          <span>{{ this.validadosNaoValidados.semAtividadesFormatado}}</span>
        </div>
        <div>
          <i class="material-symbols-outlined icon total">stacks</i>
          <b>Total de Relatórios</b>
          <span>{{ this.validadosNaoValidados.totalValidadosNaoValidadosFormatado}}</span>
        </div>

      </div>


    </div>
  </section>
  <section class="section-conteudo" aria-labelledby="conteudo-title">
    <div class="container">

      <br />
      <br />
      <h3>Ações realizadas</h3>
    
      <div class="graficos-grid" id="graficos">
        <div class="card grafico-card">
          <div class="card-body">
            <h4>Encaminhamentos em aberto</h4>
            <div class="grafico-indicador">
              {{ qtyEncaminhamentosAberto }} ({{ porcEncaminhamentosAberto }}%)
            </div>
            <canvas baseChart
                    id="chartAberto"
                    class="grafico-small"
                    [data]="barChartDataAberto"
                    [options]="barChartOptionsAberto"
                    [type]="barChartType">
            </canvas>
          </div>
        </div>
        <div class="card grafico-card">
          <div class="card-body">
            <h4>Agendamento realizado</h4>
            <div class="grafico-indicador">
              {{ qtyEncaminhamentosrealizado }} ({{ porcEncaminhamentosRealizado }}%)

            </div>
            <canvas #chartRealizado baseChart
                    id="chartRealizado"
                    class="grafico-small"
                    [data]="barChartDataRealizado"
                    [options]="barChartOptionsRealizado"
                    [type]="barChartType">
            </canvas>
          </div>
        </div>
        <div class="card grafico-card">
          <div class="card-body">
            <h4>Acolhimento concluído</h4>
            <div class="grafico-indicador">
              {{ qtyEncaminhamentosConcluidos }} ({{ porcEncaminhamentosConcluido }}%)

            </div>
            <canvas #chartConcluido baseChart
                    id="chartConcluido"
                    class="grafico-small"
                    [data]="barChartDataAcolhimento"
                    [options]="barChartOptionsAcolhimentoConcluido"
                    [type]="barChartType">
            </canvas>
          </div>
        </div>
        <div class="card grafico-card">
          <div class="card-body">
            <h4>Acolhimento em atraso</h4>
            <div class="grafico-indicador">
              {{ qtyEncaminhamentosAtraso }} ({{ porcEncaminhamentosAtraso }}%)

            </div>
            <canvas #chartAtraso baseChart
                    id="chartAtraso"
                    class="grafico-small"
                    [data]="barChartDataAtraso"
                    [options]="barChartOptionsAcolhimentoAtrasado"
                    [type]="barChartType">
            </canvas>
          </div>
        </div>
        <div class="card grafico-card">
          <div class="card-body">
            <h4>Prevenção</h4>
            <div class="grafico-indicador">
              {{ qtyEncaminhamentosPrevencao }} ({{ porcEncaminhamentosPrevencao }}%)

            </div>
            <canvas #chartPrevencao baseChart
                    id="chartPrevencao"
                    class="grafico-small"
                    [data]="barChartDataPrevencao"
                    [options]="barChartOptionsprevencao"
                    [type]="barChartType">
            </canvas>
          </div>
        </div>
      </div>
      
      <br />
      <br />
      <br />
    </div>
  </section>
</section>
<ngx-spinner bdColor="rgba(51,51,51,0.8)"
             size="medium"
             color="#fff"
             type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>
